'use strict';

import {ngDepModel} from './ngdepmodel.js';
import {evlawrcriDataModel} from './evlawrcridatamodel.js';

export class evaluationAwrcriModel extends ngDepModel
{
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}

	getValue(name){
		switch(name){
			case 'responsible':
				if(typeof(this.email) !== 'undefined'){
					return this.name + ' ' + this.lastname + ', ' + this.email;
				}
				return null;
			case 'namelastname':
				if(typeof(this.name) !== 'undefined' || typeof(this.lastname) !== 'undefined'){
					return this.name + ' ' + this.lastname;
				}
				return null;
			case 'activeemail':
				if(typeof(this.email) !== 'undefined'){
					return '<a href="mailto:'+this.email+'">'+this.email+'</a>';
				}
				return null;
			case 'term':
				if(typeof(this.term) === 'undefined' || this.term < 1){
					return null;
				}
				return this.s('$filter')('u2date')(this.term, 'dd/MM/y');
			case 'status_time':
				if(typeof(this.status_time) === 'undefined' || this.status_time < 1 || this.status < 2){
					return null;
				}
				return this.s('$filter')('u2date')(this.status_time, 'dd/MM/y HH:mm (Z)');
			case 'status_time2':
				if(typeof(this.status_time2) === 'undefined' || this.status_time2 < 1 || this.status < 2){
					return null;
				}
				return this.s('$filter')('u2date')(this.status_time2, 'dd/MM/y HH:mm (Z)');
			case 'status':
				return this.getClassifValue(name, 'evaluation_status');
			case 'passed':
				if(this.status < 2){
					return null;
				}
				return this.getClassifValue(name, 'yesno');

		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		if(typeof(this.data_value[name]) !== 'undefined'){
			return this.data_value.getValue(name);
		}
		return null;
	}

	beforeSetup(data){
		if(typeof(data.data_value) !== 'undefined'){
			data.data_value = new evlawrcriDataModel(data.data_value, this._services.$filter, this._services.jsDataService);
		}
		if(typeof(data.form_data) !== 'undefined'){
			data.form_data = new evlawrcriDataModel(data.form_data, this._services.$filter, this._services.jsDataService);
		}
	}
}
